<!-- TODO : refactor it, something like the CustomMessages component would be more convenient -->
<ul test-id="error-list" class="error-list" *ngIf="control?.errors"
    [attr.data-hidden]="control?.valid || control?.pristine">
  <li *ngIf="control?.errors.invalidBSB">{{ 'FORMS.VALIDATORS.invalidFormat' | translate }}</li>
  <li *ngIf="control?.errors.invalidIBAN">{{ 'FORMS.VALIDATORS.invalidFormat' | translate }}</li>
  <li *ngIf="control?.errors.invalidBIC">{{ 'FORMS.VALIDATORS.invalidFormat' | translate }}</li>
  <li *ngIf="control?.errors.invalidSSNFrance">{{ 'FORMS.VALIDATORS.invalidFormat' | translate }}</li>
  <li *ngIf="control?.errors.invalidEmailAddress">{{ 'FORMS.VALIDATORS.invalid_email' | translate }}</li>
  <li *ngIf="control?.errors.emailExists">{{ 'FORMS.VALIDATORS.email_exists_for_employee_within_company' | translate }}</li>
  <li
    *ngIf="control?.errors.regexp">{{ (descriptor?.regExpMessage ? descriptor?.regExpMessage : 'FORMS.VALIDATORS.invalidPattern') | translate }}</li>
  <li *ngIf="control?.errors.valueNotInList">{{ 'FORMS.VALIDATORS.valueNotInList' | translate }}</li>
</ul>
